module.exports = __webpack_public_path__ + "img/l-login.42fdaa3f.png";